import axios from 'axios'
import router from '@/router'
import store from '@/store'
import { HTTP_CODE } from '@/constants'

const request = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: process.env.VUE_APP_API_TIMEOUT,
  headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' }
})

request.interceptors.request.use(config => {
  store.commit('loader/startLoading')
  return config
}, error => {
  store.commit('loader/finishLoading')
  return Promise.reject(error)
})

request.interceptors.response.use(response => {
  store.commit('loader/finishLoading')
  return response
}, error => {
  store.commit('loader/finishLoading')
  return Promise.reject(error)
})

request.interceptors.request.use(
  config => {
    config.headers['Language'] = store.getters['language/current']
    return config
  },
  error => Promise.reject(error)
)

request.interceptors.response.use(response => response, async error => {
  if (typeof error.response === 'undefined') {
    router.replace({ name: 'error.serverError' })
  }

  if (error.response.status === HTTP_CODE.ACCESS_DENIED) {
    router.replace({ name: 'error.accessDenied' })
  }

  if (typeof error.response !== 'undefined') {
    if (error.response.status === HTTP_CODE.UNAUTHENTICATED || error.response.status === HTTP_CODE.PRE_CONDITIONS_FAILED) {
      store.commit('auth/clearToken')
      setTimeout(() => {
        router.replace({ name: 'auth.login', query: { invalid: true, sticky: 'loginExpired' } })
      }, 100)
    }
  }

  return Promise.reject(error)
})

export default request
